export function _buildQuery(params) {
    let string = ''

    for (let key in params){
        if(params[key] !== ""){
            string += `${key}=${params[key]}&`
        }
    }
    string = '?'+string.substring(0, string.length - 1)
    return string;
}

export function _buildQueryCustom(params) {
  let string = ''

  for (let key in params){
    if(params[key] !== ""){
      string += `&${key}=${params[key]}`
    }
  }
  //string = '?'+string.substring(0, string.length - 1)
  return string;
}

export function __filterCustomer() {
  return this.$http.get('/customers')
}

export function __filterCanal() {
  return ['CCMT', 'MAIL'];
}

export function __filterPriority() {
  return this.$http.get('/priorities')
}

export function __filterRequestType() {
  return this.$http.get('/categories-requests');
}
